import { Component, Renderer2, ViewChild } from '@angular/core';
import { RegistrationList } from '../registration-list/registration-list.model';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AgGridService } from 'src/app/shared/common-components/ag-grid/ag-grid.service';
import { DateRangeTypes, StorageName } from 'src/app/shared/enum/common-enum';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { RangeDatePickerComponent, SelectedDates } from 'src/app/shared/common-components/range-date-picker/range-date-picker.component';
import { AgGridDataModelMastersList, MastersRequestModelList } from '../masters/masters.model'
import { AgGridI } from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { CreateCategoryComponent } from './popup/create-category/create-category.component';
import { MastersService } from './masters.service';
import { DatePipe } from '@angular/common';
import { ModalPopupSize, NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-masters',
  templateUrl: './masters.component.html',
  styleUrls: ['./masters.component.scss']
})
export class MastersComponent extends CommonService{
  @ViewChild(RangeDatePickerComponent) rangeDatePickerComponent:RangeDatePickerComponent;
  getAllDropdown            : any = {}; 
  dateRangeTypes            = DateRangeTypes;
  timerId
  isCustomRange:any;
  agGridDataModelMastersList:AgGridI;
  rowData = [];
  totalRecords: number;
  mastersRequestModelList = new MastersRequestModelList();
  getAllMastersList : any;

  constructor(public renderer:Renderer2,
    public agGridService: AgGridService,
    public storageService : StorageService ,
    private modalService : NgbModal,
    public toaster: ToastrService,
    public mastersService: MastersService, 
    private ngbDateParserFormatter:NgbDateParserFormatter,public notificationService:NotificationService
    
  ){
    super(renderer)
  }

  ngOnInit(): void {
    this.agGridDataModelMastersList = AgGridDataModelMastersList;
    this.getDropdownData();
  }

  onGridReady($event){
    this.agGridDataModelMastersList = $event;
    this.agGridDataModelMastersList.showPagination=true;
    this.mastersRequestModelList.getAll=false;
    this.mastersRequestModelList.pageNumber=1;
    this.getAllMastersDataList();
   }

   onChnagePage(event){
    this.mastersRequestModelList.pageNumber=event?.pageNumber;
    this.mastersRequestModelList.pageSize=event?.pageSize;
    this.mastersRequestModelList.getAll=this.mastersRequestModelList.pageSize===1;
    this.getAllMastersDataList()
  }
  
  getDropdownData(){
    this.agGridService.getAllDropdownList().subscribe(()=>{
      this.getAllDropdown.dateRangeDropdown =  this.storageService.retrieve(StorageName.DATE_RANGE_DROPDOWN);
      this.getAllDropdown.countryDropdown =  this.storageService.retrieve(StorageName.COUNTRY_DROPDOWN);
    })
  }

  searchFilter(){
    this.mastersRequestModelList.pageNumber = 1;
      clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.getAllMastersDataList();
    }, 800);
  }

    getAllMastersDataList() {
    if (!this.mastersRequestModelList.fromDate || !this.mastersRequestModelList.toDate) {
        this.isCustomRange = this.dateRangeTypes.ThisMonth;
        this.range(this.isCustomRange); 	
        return; 
      }

    this.mastersService.getAllMasters(this.mastersRequestModelList).subscribe(res => {
      console.log(res);
      if (res.isSuccess) {
        this.rowData = res?.response?.data??[];
        this.getAllMastersList = res?.response?.data;
        this.totalRecords = res.totalRecords;
      }else{
        this.rowData=[];
        this.getAllMastersList = [];
        this.totalRecords =res.totalRecords;
      }
    })
  }

  range(event){
    this.isCustomRange = event;
    if(this.isCustomRange != this.dateRangeTypes.CustomRange){
      const currentDate = new Date();
      if(this.dateRangeTypes.ThisMonth ==event){
        this.mastersRequestModelList.fromDate =  this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1))  ;
        this.mastersRequestModelList.toDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) ;
      }else if(this.dateRangeTypes.LastMonth ==event){
        const lastMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  
        this.mastersRequestModelList.fromDate = this.formatDate(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth(), 1)) 
        this.mastersRequestModelList.toDate =this.formatDate (new Date(currentDate.getFullYear(), currentDate.getMonth(), 0));
      }else if(this.dateRangeTypes.YearToDate ==event){
        this.mastersRequestModelList.fromDate = this.formatDate(new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate())) ; // Current date of last year
        this.mastersRequestModelList.toDate = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) ;
      }
      this.getAllMastersDataList()
    }else if(this.isCustomRange == this.dateRangeTypes.CustomRange){
      setTimeout(() => {
      this.rangeDatePickerComponent.inputDate=null;
      }, 100);
    }
  }

  openCreateCategoryPopup(params?): void {
    const copyOfObject = { ...params?.detail?.data?.data };
    const data = {
      rowData: copyOfObject, templateData: { countryDropdown: this.getAllDropdown.countryDropdown }
    };

    this.notificationService.openModalPopup(CreateCategoryComponent, data, 'Create Category', ModalPopupSize.MD).then(res => {
      if (res) {
        this.getAllMastersDataList();
      }
    });
  }


  deleteMastersList(event){
    let id = event?.detail?.data?.data?.id;
    this.mastersService.deleteMasters(id).subscribe((res)=>{
      if(res?.isSuccess){
        this.toaster.success(res.message);
        this.getAllMastersDataList();
      }else{
        this.toaster.error(res.message);
      }
    })
  }

  selectedRangeDates(selectedDates:SelectedDates){
    console.log('selectedRangeDates');
    if(selectedDates?.endDate && selectedDates?.startDate){
    const startdate = this.ngbDateParserFormatter.format(selectedDates?.startDate);
    const endtdate = this.ngbDateParserFormatter.format(selectedDates?.endDate);
    const datePipe = new DatePipe('en-US');
    this.mastersRequestModelList.fromDate =  datePipe?.transform(startdate , "yyyy-MM-ddT00:00:00");
    this.mastersRequestModelList.toDate   =  datePipe?.transform(endtdate , "yyyy-MM-ddT00:00:00");
    this.getAllMastersDataList() 
   }
  }

  selectedRangeDatesClear(){
    this.mastersRequestModelList.fromDate = '';
    this.mastersRequestModelList.toDate   = '';
    this.getAllMastersDataList()
  }

}
